<template>
  <!--  区域经理新增编辑弹窗 -->
  <el-dialog
    :title="title"
    :visible.sync="showInfo"
    v-if="showInfo"
    width="50%"
    class="dialog"
    center
  >
    <div class="infoWrap">
      <el-form
        :model="formData"
        ref="refForm"
        :rules="formRules"
        label-width="200px"
      >
        <el-form-item prop="logistic_business_id" label="集配中心">
          <el-select
            v-model="formData.logistic_business_id"
            clearable
            placeholder="请选择集配中心"
            :disabled="formData.id ? true : false"
          >
            <el-option
              v-for="item of options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="fullname" label="区域经理">
          <el-input v-model="formData.fullname" placeholder="输入账号">
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="电话">
          <el-input v-model="formData.mobile" placeholder="输入电话">
          </el-input>
        </el-form-item>
        <el-form-item label="选择管辖区域" prop="area_list">
          <el-cascader
            :options="areaList"
            :props="props"
            clearable
            filterable
            v-model="formData.area_list"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="选择城市仓" prop="logistics_ids">
          <el-select
            v-model="formData.logistics_ids"
            placeholder="选择城市仓"
            filterable
            multiple
            clearable
          >
            <el-option
              :key="index"
              :label="item.name"
              :value="item.id"
              filterable
              v-for="(item, index) in tdcList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-radio-group v-model="formData.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showInfo = false">取 消</el-button>
      <el-button type="primary" @click="submitFrom" :loading="submitLoading"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
import { postRegionalmanageSave } from "@/api/general/manager.js";
export default {
  name: "editManagerDialog",
  props: ["tdcList", "options", "areaList"],
  data() {
    return {
      showInfo: false,
      detailInfo: {},
      type: "",
      formData: {
        id: "",
        logistic_business_id: "",
        fullname: "",
        mobile: "",
        area_list: [],
        logistics_ids: [],
        state: "",
      },
      formDataClone: {},
      formRules: {
        logistic_business_id: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请选择集配中心",
          },
        ],
        fullname: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请输入区域经理名称",
          },
        ],
        mobile: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请输入手机号",
          },
        ],
        area_list: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请选择管辖区域",
          },
        ],
        logistics_ids: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请选择城市仓",
          },
        ],
        state: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请选择状态",
          },
        ],
      },
      title: "新增",
      props: {
        multiple: true,
        emitPath: false,
        value: "area_code", //	指定选项的值为选项对象的某个属性值	string	—	'value'
        label: "name", //	指定选项标签为选项对象的某个属性值	string	—	'label'
        children: "child", //	指定选项的子选项为选项对象的某个属性值
      },
      submitLoading: false,
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
  },
  methods: {
    handleChange(e) {
      console.log(e, this.formData, "eee");
    },
    /**
     * 提交表单
     */
    submitFrom: debounce(function () {
      this.$refs.refForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let params = JSON.parse(JSON.stringify(this.formData));

        this.submitLoading = true;
        try {
          await postRegionalmanageSave(params);
          if (params.id) {
            this.tool.message("编辑成功", "success");
          } else {
            this.tool.message("添加成功", "success");
          }
          this.showInfo = false;
          this.$emit("submit-form"); // 刷新列表
        } catch (error) {
          console.error("postRegionalmanageSave", error);
        } finally {
          this.submitLoading = false;
        }
      });
    }, 300),
    /**
     * 初始化
     */
    async onInitData(row, type) {
      this.detailInfo = row;
      this.title = type;
      console.log(row, type, "rww");
      this.$refs.refForm?.clearValidate();
      this.formData = {
        ...this.formDataClone,
      };
      if (row && row.id) {
        console.log("编辑");
        const {
          id,
          logistic_business_id,
          fullname,
          mobile,
          area_list,
          logistics,
          state,
        } = row;
        const params = {
          id,
          logistic_business_id,
          fullname,
          mobile,
          area_list,
          logistics,
          state,
        };
        // 将表单需要的数据赋值
        Object.keys(this.formData).forEach((_KEY) => {
          this.formData[_KEY] = params[_KEY];
        });
        this.formData.area_list = area_list.map((mItem) => mItem.city_code);
        this.formData.logistics_ids = logistics.map((LItem) => LItem.id);
        console.log(this.formData, "eee");
      }
      this.showInfo = true;
    },

    /**
     * 关闭操作
     */
    onHandleClose() {
      this.showInfo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.infoWrap {
  padding-top: 20px;
  display: flex;
  /deep/ .el-input {
    width: 300px !important;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0px;
  }
}
</style>
